// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabs-container{width:100%;display:flex;justify-content:space-between;align-items:center;gap:20px}.tab-wrapper{background:none;border:none;padding:0;outline:inherit;cursor:pointer;width:100%;display:flex;justify-content:center;align-items:center;padding:10px 20px;border-bottom:1px solid #d8d5dd;transition:all .3s}.tab-wrapper-active{border-bottom:1px solid #ff6990}.tab-text{color:#a49cb0 !important}.tab-text-active{color:#3f3947 !important}", ""]);
// Exports
module.exports = exports;
